export default __webpack_public_path__ + "static/media/help-icon.9285bd95.svg";